import { Typography } from "@mui/joy";
import { currencyColumn, dateColumn, genericColumn, getColumnValue, numberColumn, primaryRelationshipColumn, relationshipColumn, selectColumn, textColumn, yesNoColumn } from "./columnHelpers";
import { designations } from "@utils/selectOptions";

export const registriesRelationship = {
    collapsible: true,
    title: 'Registries',
    tint: 'default',
    type: 'table',
    columns: [
        relationshipColumn({
            label: 'Registry',
            endpoint: 'registries',
            // column: 'name',
            width: '60%',
        }),
        // textColumn({label: 'Registry', column: 'name', width: '60%'}),
        selectColumn({
            label: 'Designation',
            column: 'pivot.designation',
            options: designations,
        }),
    ],
};
